import template from './bLineChart.html';
import moment from 'moment';
import d3 from 'd3';

const TIME_PER_UNIT_COLOR = '#D2D7D4';
const VOLUME_COLOR = '#3ABE7C';

export function bLineChartDirective() {
  'ngInject';

  return {
    restrict: 'E',
    template: template,
    controller: bLineChartController,
    controllerAs: 'bLineChart',
    bindToController: true,
    scope: {
      canShare: "=",
      data: "=",
      title: "@",
      tooltipId: "@",
      type: "@",
      onShareChart: "&",
      onExportChart: "&"
    }
  };
}

class bLineChartController {

  constructor($filter, $scope, $translate) {
    'ngInject';

    this.$filter = $filter;
    this.$scope = $scope;
    this.$translate = $translate;
    this.$scope.$watch(() => this.data, newValue => this.updateChart(newValue));
  }

  canRender() {
    return this.lineData && this.lineData.length;
  }

  exportChart() {
    this.onExportChart({
      exportData: {
        type: this.type === 'hours' ? 'vol-slicer-hours' : 'vol-slicer-volume',
        data: {}
      }
    });
  }

  shareChart() {
    const type = this.type === 'hours' ? 'vol_slicer_hours' : 'vol_slicer_volume';
    const shareData = {type: type, data: this.data, selected: this.selectedData};
    this.onShareChart({shareData});
  }

  updateChart(newValue) {
    const tooltipId = this.tooltipId;
    this.lineData = [];
    var tooltipData = [];
    var filter = this.$filter;
    this.selectedData = newValue.selectedProcesses.slice().sort();
    delete newValue.selectedProcesses;

    if (this.selectedData.length) {
      Object.keys(newValue).forEach(key => {
        this.lineData.push({
          x: moment(key, 'YYYY-MM').valueOf(),
          y: newValue[key].value,
          label: this.type === 'hours' ? this.$filter('hms')(moment.duration(newValue[key].value).toJSON()) : newValue[key].value
        });
      });
      tooltipData = JSON.parse(JSON.stringify(this.lineData));
    }

    const chartSizeConst = {
      xTickPadding: 28,
      yTickPadding: 30,
      xLabelHeight: 20,
      chartHeight: 235
    };
    this.chartOptions = {
      chart: {
        type: 'lineChart',
        noData: this.$translate.instant('NOTHING_TO_SHOW'),
        height: chartSizeConst.chartHeight,
        showLegend: false,
        showLabels: this.lineData.length <= 12,
        clipEdge: false,
        margin: {
          left: 22,
          right: 12,
          top: 10,
          bottom: chartSizeConst.xLabelHeight + chartSizeConst.xTickPadding
        },
        callback: () => {
         this.updateLabels(tooltipId);
        },
        tooltip: {
          position: () => {
            const tooltipEl = angular.element(document.getElementById(`view-360-tooltip-${tooltipId}`));
            const parent = tooltipEl.parent();
            if (tooltipEl && parent && !parent.hasClass('view-360-tooltip')) {
              parent.addClass('view-360-tooltip');
            }
            const point = d3.select('.nv-point.hover');
            if (point.empty()) {
              return {};
            }

            const ctm = point.node().getScreenCTM();
            return {top: ctm.f - 38, left: ctm.e - 40};
          },
          contentGenerator: (d) => {
            const month = moment(tooltipData[d.pointIndex].x).format('MMMM').toUpperCase();
            let value = 0;
            if (this.type === 'hours') {
              const duration = moment.duration(d.point.y).toJSON();
              value = filter('hms')(duration);
            } else {
              value = d.point.y;
            }
            return `
                  <div id="view-360-tooltip-${tooltipId}" class="view-360-tooltip-inner">
                    <div>${month}</div>
                    <div>${value}</div>
                </div>`;
          }
        },
        xAxis: {
          tickPadding: chartSizeConst.xTickPadding,
          tickValues: d => d[0].values.map(v => v.x),
          tickFormat: d => moment(d).format('MMM').toUpperCase()
        },
        yAxis: {
          tickPadding: chartSizeConst.yTickPadding,
          tickValues: d => {
            const vals = d[0].values.map(v => v.y);
            const max = Math.round(Math.max(...vals));
            const min = Math.round(Math.min(...vals));
            const tickVal = min === max ? Math.abs(max) : Math.floor(Math.abs(max - min) / 5);

            if (max === 0 || !tickVal) {
              return [];
            }
            const tickVals = [];
            for (let t = 0; t <= max; t += tickVal) {
              tickVals.push(t);
            }
            return tickVals;
          },
        }
      },
      data: [
        {
          values: this.lineData,
          key: 'line-data',
          color: this.type === 'hours' ? TIME_PER_UNIT_COLOR : VOLUME_COLOR
        }
      ]
    };
  }

  updateLabels(tooltipId){
    const labels = d3.selectAll(`#line-chart-${tooltipId} .nv-label`);
    labels[0].forEach((label, idx) => {
      const translateVal = label.getAttribute('transform')
        .replace('translate', '')
        .replace('(', '')
        .replace(')', '');

      let pos = translateVal.indexOf(',') > -1 ? translateVal.split(',') : translateVal.split(' ');
      pos = pos.map(p => parseFloat(p));
      if (pos.length !== 2) {
        pos.push(0);
      }

      if (idx === labels[0].length - 1 && this.type === 'hours') {
        label.setAttribute('transform', `translate(${pos[0] - 40}, ${pos[1] - 15})`);
      } else {
        label.setAttribute('transform', `translate(${pos[0] - 15}, ${pos[1] + 15})`);
      }
    });
  }
}
